import { render } from "./OffersView.vue?vue&type=template&id=28028fd0&scoped=true"
import script from "./OffersView.vue?vue&type=script&lang=js"
export * from "./OffersView.vue?vue&type=script&lang=js"

import "./OffersView.vue?vue&type=style&index=0&id=28028fd0&scoped=true&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=1&lang=css"

import exportComponent from "/var/www/dev.newtoncommoditiesscripts.com/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28028fd0"]])

export default __exports__